import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  ShoppingCartIcon,
  CurrencyDollarIcon,
  TruckIcon,
  Squares2X2Icon,
} from '@heroicons/react/24/outline';

const mobileNavItems = [
  { name: 'Home', href: '/', icon: HomeIcon },
  { name: 'Purchases', href: '/purchases', icon: ShoppingCartIcon },
  { name: 'Sales', href: '/sales', icon: CurrencyDollarIcon },
  { name: 'Transportation', href: '/transportation', icon: TruckIcon },
  { name: 'More', href: '#', icon: Squares2X2Icon },
];

export default function MobileNavigation({ onMoreClick }) {
  const location = useLocation();

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white dark:bg-[#1D2430] border-t border-gray-200 dark:border-gray-800 lg:hidden transition-colors duration-300">
      <nav className="flex justify-around">
        {mobileNavItems.map((item) => (
          item.name === 'More' ? (
            <button
              key={item.name}
              onClick={onMoreClick}
              className="flex flex-col items-center p-3 text-gray-500 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-500"
            >
              <item.icon className="h-6 w-6" />
              <span className="text-xs mt-1">{item.name}</span>
            </button>
          ) : (
            <Link
              key={item.name}
              to={item.href}
              className={`flex flex-col items-center p-3 ${
                location.pathname === item.href
                  ? 'text-primary-600 dark:text-primary-500'
                  : 'text-gray-500 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-500'
              }`}
            >
              <item.icon className="h-6 w-6" />
              <span className="text-xs mt-1">{item.name}</span>
            </Link>
          )
        ))}
      </nav>
    </div>
  );
}